<template>
  <div class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="维护签约任务"></Title>
    <div style="margin-bottom: 60px;">
    <!-- 合同信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同名称：</div>
          <!-- <el-select
            v-if="$route.query.toType != 3"
            v-model="formDataPage.contractGuid"
            filterable
            class="contract-base-content"
            placeholder="请选择"
            @change="getContractDetail"
          >
            <el-option v-for="item in contractList" :key="item.guid" :label="item.contractName" :value="item.guid">
            </el-option>
          </el-select> -->
          <el-input
            v-if="$route.query.toType != 3"
            v-model="formDataPage.contractName"
            filterable
            class="contract-base-content"
            placeholder="请选择"
            @focus="dialogVisible = true"
          ></el-input>
          <!-- 重新提交 合同名称不能改 -->
          <el-input
            v-else
            disabled
            v-model.trim="formData.contractName"
            class="contract-base-content"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>签约时间：</div>
          <el-date-picker
            disabled
            class="contract-base-content"
            v-model="formData.signDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同有效期至：</div>
          <el-date-picker
            disabled
            class="contract-base-content"
            value-format="yyyy-MM-dd"
            v-model="formData.validityDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>甲方名称：</div>
          <el-input
            disabled
            v-model.trim="formData.tenantName"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>乙方名称：</div>
          <el-select
            disabled
            filterable
            v-model="formData.serviceTenantGuid"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>运营经理：</div>
          <el-input
            disabled
            v-model.trim="formData.projectManagerName"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>公司类型：</div>
          <el-select disabled v-model="formData.enterpriseCate" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('平台企业类型')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同类型：</div>
          <el-select
            disabled
            clearable
            v-model="formData.contractType"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in getCodeListByKey('合同类型')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同内容：</div>
          <el-select disabled v-model="formData.contractContent" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('合同内容分类')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同金额(元)：</div>
          <el-input
            disabled
            v-model.trim="formData.contractMoney"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>业务类型：</div>
          <el-select disabled v-model="formData.contractContentType" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in contractContentTypeOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>业务类型内容：</div>
          <el-select disabled v-model="formData.contractContent" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey(
                formData.contractContentType == 1
                  ? '业务收入类型'
                  : formData.contractContentType == 2
                  ? '业务支出类型'
                  : [],
              )"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票方式：</div>
          <el-select disabled v-model="formData.invoiceMode" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in invoiceModeOptions" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>结算依据：</div>
          <el-select disabled v-model="formData.balanceBasis" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in balanceBasisOptions" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>维保条件：</div>
          <el-select disabled v-model="formData.maintainCondition" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('维保条件')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否垫资：</div>
          <el-radio-group disabled v-model="formData.isAdvanceMoney" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>

        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>任务价格是否含税：</div>
          <el-radio-group disabled v-model="formData.isContainTax" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否补充协议：</div>
          <el-radio-group disabled v-model="formData.isSupplementAgreement" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同附件：</div>
          <div>
            <div v-for="(item, index) in fileList" :key="index">
              <div class="contract-file-inform">
                <img
                  width="32"
                  height="32"
                  class="mr10"
                  :src="
                    item.type == 'word'
                      ? require('../../assets/images/word_icon.png')
                      : require('../../assets/images/pdf_icon.png')
                  "
                  alt=""
                /><span> {{ item.name }}</span
                ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看详情</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 产品信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">产品信息</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red">*</span>签约产品：</div>
          <el-select
            disabled
            v-model="contractProductList"
            filterable
            multiple
            class="contract-base-content w75f"
            placeholder="请选择"
          >
            <el-option
              v-for="item in getCodeListByKey('传世产品线')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <!-- 付款方式 -->
    <div class="contract-base-box">
      <p class="contract-base-name">付款方式</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="24">
          <!-- 1月度 2季度 3年度 4进度 -->
          <div class="contract-base-title"><span class="fontC-red">*</span>付款方式：</div>
          <el-select disabled v-model="formData.payType" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('付款方式')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- 方式为进度时  -->
        <template v-if="formData.payType == '4'">
          <el-col :span="24" v-for="(item, index) in payTypeJsonList" :key="index">
            <div class="contract-base-title"><span class="fontC-red">*</span>回款比例(%)：</div>
            <div>
              <el-select
                disabled
                v-model="item.selectType"
                style="width: 150px; margin-right: 13px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getCodeListByKey('费用类型')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                disabled
                style="width: 150px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="12"
                v-model.trim="item.selectValue"
                placeholder="请输入"
                clearable
              ></el-input>
            </div>
          </el-col>
        </template>
        <!-- 方式为月度时  -->
        <template v-if="formData.payType == '1'">
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>收费比例(%)：</div>
            <el-input
              disabled
              v-model.trim="formData.chargeRate"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="5"
              class="contract-base-content"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>下发扣除税点(%)：</div>
            <el-input
              disabled
              v-model.trim="formData.sendTaxDeduction"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="5"
              class="contract-base-content"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>是否内扣：</div>
            <el-radio-group disabled v-model="formData.isInsideDeduction" class="contract-base-content">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-col>
        </template>
        <!-- 方式为季度时 -->
        <template v-if="formData.payType == '2'">
          <el-col :span="24" v-for="(item, index) in payTypeJsonList" :key="index">
            <div class="contract-base-title"><span class="fontC-red">*</span>回款金额(元)：</div>
            <div>
              <el-select
                disabled
                v-model="item.selectType"
                style="width: 150px; margin-right: 13px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getCodeListByKey('季度选项')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                disabled
                style="width: 150px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="12"
                v-model.trim="item.selectValue"
                placeholder="请输入"
                clearable
              ></el-input>
            </div>
          </el-col>
        </template>
        <!-- 方式为年度时 -->
        <template v-if="formData.payType == '3'">
          <el-col :span="24" v-for="(item, index) in payTypeJsonList" :key="index">
            <div class="contract-base-title"><span class="fontC-red">*</span>回款金额(元)：</div>
            <div>
              <el-select
                disabled
                v-model="item.selectType"
                style="width: 150px; margin-right: 13px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getCodeListByKey('年度选项')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                disabled
                style="width: 150px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="12"
                v-model.trim="item.selectValue"
                placeholder="请输入"
                clearable
              ></el-input>
            </div>
          </el-col>
        </template>
      </el-row>
    </div>
    <!-- 银行信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">银行信息</p>
      <el-row :gutter="24" v-for="(item, index) in formData.contractBankList" :key="index" class="mb20">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户银行：</div>
          <el-input
            disabled
            v-model.trim="item.bankName"
            class="contract-base-content"
            :maxlength="30"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户账号：</div>
          <el-input
            disabled
            v-model.trim="item.bankAccount"
            class="contract-base-content"
            :maxlength="50"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>税号：</div>
          <el-input
            disabled
            v-model.trim="item.bankTaxNo"
            class="contract-base-content"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="18"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>开户行号：</div>
          <el-input
            disabled
            v-model.trim="item.bankNo"
            class="contract-base-content"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="50"
            placeholder="请输入"
            clearable
          ></el-input>
          <div class="add-bank-box"></div>
        </el-col>
      </el-row>
    </div>
    <!-- 签约任务 -->
    <div class="contract-base-box">
      <p class="contract-base-name">签约任务</p>
      <p class="contract-base-button" :style="isBatch?'':'margin-left:50px'">
        <el-checkbox v-if="isBatch" style="margin-right: 10px" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>

        <el-dropdown class="dropdownlist" @command="handleCommand" v-if="commandType==1">
          <!-- <el-button  type="primary" size="small">批量设置</el-button> -->
           <div class="setting-btn">批量设置</div>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">批量作废</el-dropdown-item>
              <el-dropdown-item command="2">批量启用</el-dropdown-item>
              <el-dropdown-item command="3">批量删除</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <el-button  type="primary" size="small" @click="isBatch=false;commandType=1;buttonTxt='';" v-else>取消批量</el-button>

        <!-- <el-button @click="batchDelete(1)" type="primary" size="small">批量作废</el-button>
        <el-button @click="batchDelete(2)" type="primary" size="small">批量启用</el-button>
        <el-button @click="batchDelete(3)" type="primary" size="small">批量删除</el-button> -->
        <el-button v-if="buttonTxt" @click="batchAudit()" type="primary" size="small">{{ buttonTxt }}</el-button>
      </p>
      
      <el-row :gutter="24" v-for="(item, index) in formDataPage.contractTaskDetailList" :key="index" class="mb0">
        <div class="contract-base-title">
            <el-checkbox 
              v-if="isBatch"
              v-model="item.checked"
              @change="handleCheckedChange(item,index)"
              :disabled="item.disabled"
              style="margin-right: 10px"
            ></el-checkbox>
        <span class="fontC-red">*</span>签约任务 <span style="display:inline-block;width:16px">{{ index + 1 }}：</span></div>
        <el-col :span="16" style="display: flex;align-items: center;padding-left:60px">
          <el-select
            size="mini"
            ref="taskSelect"
            style="min-width: 180px; margin-right: 10px"
            :disabled="item.isContractTask=='Y'"
            filterable
            v-model="item.templateDetailGuid"
            placeholder="请选择任务"
            @change="taskChange(item.templateDetailGuid, index, 'templateDetailGuid')"
          >
            <el-option v-for="item in taskList" :key="item.guid" :label="item.taskName" :value="item.guid">
            </el-option>
          </el-select>
          <el-input
             size="mini"
            style="min-width: 180px; margin-right: 10px"
            v-model.trim="item.taskContentName"
            placeholder="请输入项目任务名称"
            clearable
          ></el-input>

          <el-select
             size="mini"
            ref="taskSelect"
            style="min-width: 100px;max-width:100px; margin-right: 10px"
            filterable
            v-model="item.priceType"
            @change ="priceTypeChange(item.templateDetailGuid, index, item.priceType)"
            placeholder="请选择价格类型"
          >
          <el-option
              v-for="item in getCodeListByKey('任务定价模式')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
            <!-- <el-option v-for="item in [{label:'固定价',value:'1'},{label:'区间价',value:'2'}]" :key="item.value" :label="item.label" :value="item.value">
            </el-option> -->
          </el-select>
          <el-input
             size="mini"
            v-if="item.priceType==1"
            style="min-width: 110px;max-width:110px;margin-right: 10px"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            v-model.trim="item.taskPrice"
            placeholder="固定价格"
            clearable
          ></el-input>

          <el-input
             size="mini"
             v-if="item.priceType==2"
            style="min-width:94px;max-width:94px;margin-right: 10px"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            v-model.trim="item.taskPrice"
            placeholder="最低价格"
            clearable
          ></el-input>
          <el-input
             size="mini"
            v-if="item.priceType==2"
            style="min-width: 94px;max-width:94px"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            v-model.trim="item.maxTaskPrice"
            placeholder="最高价格"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="8" style="padding-left: 0;">
          <el-input
             size="mini"
            v-model.trim="item.taskDescription"
            placeholder="备注（填写工业对该任务的个性化要求）"
            clearable
          ></el-input>
          <div class="add-bank-box" style="min-width: 120px;text-align: left;line-height:28px;">
            <span class="mr10" v-show="formDataPage.contractTaskDetailList.length == index + 1" @click="addSigning"
              >添加任务</span
            >
            <span class="mr10" v-if="item.isContractTask!=='Y'" @click="delSigning(item)">删除</span>
            <span v-else @click="changeState(item)">{{ item.bizState=='S'?'重新启用':'作废' }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 上传合同盖章附件 -->
    <div class="contract-base-box" v-if="formData.logisticsInfoDTO && formData.logisticsInfoDTO.bizGuid">
      <p class="contract-base-name">合同盖章附件</p>
      <el-row :gutter="24">
        <el-col :span="12" v-if="formData.isMail=='Y'">
          <span class="contract-base-title">快递公司：</span>
          <div class="contract-base-content">{{ formData.logisticsInfoDTO.expressCompany }}</div>
        </el-col>
        <el-col :span="12" v-if="formData.isMail=='Y'">
          <span class="contract-base-title">快递单号：</span>
          <div class="contract-base-content">{{ formData.logisticsInfoDTO.expressNo }}</div>
        </el-col>
      </el-row>
      <!-- 附件 -->
      <div class="contract-base-box">
        <div class="contract-apply-file">
          <span>合同附件：</span>
          <div>
            <div v-for="(item, index) in ccFileList" :key="index">
              <div class="contract-file-inform">
                <img
                  width="32"
                  height="32"
                  class="mr10"
                  :src="
                    item.type == 'word'
                      ? require('../../assets/images/word_icon.png')
                      : require('../../assets/images/pdf_icon.png')
                  "
                  alt=""
                /><span> {{ item.fileName }}</span
                ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe  :src="srcs" class="iframe-sty"></iframe>
    </div>
  </div>
    <!-- 提交 -->
    <div class="submit-btn-box submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button
        type="borderGreen"
        v-if="!$route.query.guid || $route.query.approveStateTask == 'N'"
        size="small"
        @click="saveReq(0)"
        >保存草稿</el-button
      >
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>
    <!-- 合同信息弹窗 -->

    <el-dialog title="合同信息" :visible.sync="dialogVisible" width="820px"  class="dialog-title">
          <div class="search-area">
          <el-row :gutter="24">
            
            <el-col :span="8" class="span-flex"
              ><div class="search-area-div">甲方名称：</div>
              <el-select filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择">
                <el-option
                  v-for="item in tenantList"
                  :key="item.tenantGuid"
                  :label="item.tenantName"
                  :value="item.tenantGuid"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8" class="span-flex"
              ><div class="search-area-div ">乙方名称：</div>
              <el-select filterable clearable v-model="page.serviceTenantGuid" class="ipt-sty" placeholder="请选择">
                <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <!-- <el-button
                size="mini"
                type="text"
                @click="showMore = !showMore"
                :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              >
                {{ showMore ? '收起筛选' : '更多筛选' }}
              </el-button> -->
              <el-button size="mini" type="info" @click="getContractList(1)">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
            >
          </el-row>
          
          </div>
          <div class="back-color-fff content-main-box" style="height: 100%">
            <el-table
              :data="contractList"
              stripe
              border
              :height="tableHeight"
              style="width: 100%"
              @cell-click="getTableData"
            >
              <el-table-column
                property="contractCode"
                label="合同编号"
                width="150"
                header-align="center"
                align="left"
              ></el-table-column>
              <el-table-column
                property="contractName"
                label="合同名称"
                width="200"
                header-align="center"
                align="left"
              ></el-table-column>
              <el-table-column
                property="tenantName"
                label="甲方名称"
                width="200"
                header-align="center"
                align="left"
              ></el-table-column>

              <el-table-column
                property="serviceTenantName"
                label="乙方名称"
                width="220"
                header-align="center"
                align="left"
              ></el-table-column>
            </el-table>
          </div>
          <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
          </el-pagination>
        
    </el-dialog>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import { bpmnroute } from '@/api/apiRoute';
import store from '@/store';
import Title from '@/components/title/title.vue';
export default {
  components: {
    Title,
  },
  data() {
    return {
      commandType:1,
      isBatch:false,
      buttonTxt:'',
      checkAll: false,
      isIndeterminate: false,
      conItems:[],
      tableHeight: window.innerHeight - 340,
      exportUrl: `/${serverConfig.msCommonImportDataService}/import-data/import-common`,
      flowType: '00011',
      fullscreenLoading: false,
      tenantList: [], //甲方
      serviceTenantList: [], //乙方
      taskList: [],
      contractList: [],
      contractContentTypeOptions: [
        {
          text: '业务收入',
          value: '1',
        },
        {
          text: '业务支出',
          value: '2',
        },
      ],
      invoiceModeOptions: ['先款后票', '先票后款'], //发票方式
      balanceBasisOptions: ['结算单', '结算单+运营报告', '结算单+验收报告'], //票据方式
      // 表单内容
      formDataPage: {
        guid: null,
        staffGuid: null, //申请人
        staffName: null, //申请人姓名
        discardContractGuid: null, //待废弃合同GUID
        contractGuid: null,
        contractTaskDetailList: [
          {
            guid: null,
            templateDetailGuid: null,
            oldTaskContentName: null,
            taskContentName: null,
            taskPrice: null,
            taskDescription: null,
            isContractTask:'N',
            priceType:'1',
            maxTaskPrice:'',
          },
        ],
      },
      formData: {},
      staffList: [],
      contractProductList: [],
      payTypeJsonList: [],
      fileList: [],
      ccFileList:[],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      dialogVisible: false,
      // 分页
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', //甲方
        serviceTenantGuid: '', //乙方
        staffGuid: '',
        contractName: '',
        approveState: '',
      },
    };
  },
  created() {
    this.getFlowGuid();
    this.getTaskList();
    this.getTenantList();
    this.getServiceTenantList();
    this.getContractList();
    if (this.$route.query.contractGuid) {
      this.formDataPage.contractGuid = this.$route.query.contractGuid;
      this.getContractDetail();
    }
    // this.$nextTick(()=>{
    //   let dropdownlist = document.getElementsByClassName('dropdownlist')
    //   for(let drop in dropdownlist){
    //     let dropItem = dropdownlist[drop]
    //     if(typeof dropItem =='object'){
    //       dropItem.style.display = 'none'
    //     }
    //   }
    // })


    },
  methods: {
    // 获取表格数据
    getTableData(row, column, cell, event) {
      console.log('row', row, column, cell, event);
      this.$confirm(`确认选择：${row.contractName}吗？`, '合同名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'warning'
      })
        .then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!',
          // });
          this.formDataPage.contractName = row.contractName;
          this.formDataPage.contractGuid = row.guid;
          console.log('this.contractName', this.formDataPage.contractName);

          this.dialogVisible = false;
          this.getContractDetail();
        })
        .catch(() => {
          this.contractName = '';
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    //获取甲方
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        approveState: 'Y',
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/projectApply/list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取合同
    getContractList(type) {
      let self = this;
      if (type == 1) {
        self.page.pageIndex = 1;
      }
      
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        pageIndex: self.page.pageIndex,
        pageSize: self.page.pageSize,
        approveState: 'Y',
        isNotTask: 'Y',
        projectManagerGuid: userinfo.staffGuid,
        tenantGuid: self.page.tenantGuid, //甲方
        serviceTenantGuid: self.page.serviceTenantGuid, //乙方
        staffGuid: self.page.staffGuid,
        contractName: self.page.contractName,
      }
      self.api.postJson(`/${serverConfig.msCustomerService}/contract/list`, query).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.contractList = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //查看附件
    toSee(item, index) {
      let path = item.path;
      if (path.indexOf('.pdf' || '.PDF') > -1) {
        window.open(path);
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path));
      }
    },
    handleCommand(type){
      this.commandType = 2;
      this.batchDelete(type)
    },
    // 批量操作 tpye 1 作废 2启用 3删除
    batchDelete(type) {
      if (this.formDataPage.contractTaskDetailList.length==1&&!this.formDataPage.contractTaskDetailList[0].templateDetailGuid) {
        this.commandType = '1';
        this.$message.error('暂无数据');
        return;
      }
      this.isBatch = false;
      this.checkAll = false
      this.isIndeterminate = false;
      this.buttonTxt = type == 1 ? '设为作废' : type == 2 ? '设为启用' : '删除';
      this.formDataPage.contractTaskDetailList.forEach(item => {
        // item.disabled=type==3?item.isContractTask=='Y':type==2?item.bizState=='S':item.bizState!=='S'
        if(!item.templateDetailGuid&&this.formDataPage.contractTaskDetailList.length<2){
          console.log('1');
          
          item.disabled=true
        }
        if(type==3){
          item.disabled=item.isContractTask!=='Y'?false:true
        }else{
          console.log('3');
          
          item.disabled=item.isContractTask!=='Y'?true:type==2?(item.bizState!=='S'):(item.bizState=='S')
          
          
        }
        console.log('dis',item);
        
        item.checked=false

      })
      this.$forceUpdate()
      this.isBatch = true;
    },
    batchAudit(){
      // this.formDataPage.contractTaskDetailList.forEach((item) => {
      //     if (item.checked) {
      //       let obj = {
              
      //       };
      //       this.conItems.push(obj);
      //     }
      //   });
      if(this.buttonTxt=='删除'){
        this.delSigning()
      }else{
        this.changeState()
      }
      
      
    },
    //全选
    handleCheckAllChange() {
      
      this.formDataPage.contractTaskDetailList.forEach((i) => {
        if (!i.disabled) i.checked = this.checkAll;
      });
      this.isIndeterminate = false;
    },
    handleCheckedChange(item,index){
      console.log('item',item);
      let list1=this.formDataPage.contractTaskDetailList.filter(item=>!item.disabled)
      let list2=this.formDataPage.contractTaskDetailList.filter(item=>item.checked)
      this.checkAll = list1.length === list2.length;
      this.isIndeterminate = list2.length > 0 && list2.length < list1.length;
      this.$set(this.formDataPage.contractTaskDetailList[index],'checked',item.checked)
      this.$forceUpdate()
    },
    //获取详情
    getContractDetail(val) {
      let self = this;
      let type=''//新增1
      if(this.$route.query.guid){
        type='2'
      }else{
        type='1'
      }
      self.api
        .get(`/${serverConfig.msCustomerService}/contract/detail-approve-task?guid=${self.formDataPage.contractGuid}&selectType=${type}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData = res.data.data;
            self.payTypeJsonList = JSON.parse(self.formData.payTypeJson);
            (self.formData.signDate = self.$moment(self.formData.signDate).format('YYYY-MM-DD')), //签约时间
              (self.formData.validityDate = self.$moment(self.formData.validityDate).format('YYYY-MM-DD')); //合同有效期
            //附件
            if (self.formData.contractUrl) {
              self.fileList = JSON.parse(self.formData.contractUrl);
              self.fileList.forEach((i) => {
                if (i.path.indexOf('.pdf' || '.PDF') > -1) {
                  i.type = 'pdf';
                } else {
                  i.type = 'word';
                }
              });
            }
            if (self.formData.electronicContractFileList) {
              self.ccFileList = self.formData.electronicContractFileList;
              self.ccFileList.forEach((i) => {
                if (i.path.indexOf('.pdf' || '.PDF') > -1) {
                  i.type = 'pdf';
                } else {
                  i.type = 'word';
                }
              });
            }
            // 产品——每次加载合同详情前重建选中数组，防止切换/重选合同时标签累积
            self.contractProductList = [];
            if (self.formData.contractProductList && self.formData.contractProductList.length > 0) {
              self.formData.contractProductList.forEach((k) => {
                self.contractProductList.push(k.productGuid);
              });
            }
            //签约任务
            self.formDataPage.contractName=res.data.data.contractName
            self.formDataPage.contractTaskDetailList = self.formData.contractTaskDetailList || [
              {
                guid: null,
                templateDetailGuid: null,
                oldTaskContentName: null,
                taskContentName: null,
                taskPrice: null,
                taskDescription: null,
                isContractTask:'N',
                priceType:'1',
                maxTaskPrice:'',
                // isChecked:false,
                // state:'Y',//默认状态启用
              },
            ];
            if (self.formDataPage.contractTaskDetailList && self.formDataPage.contractTaskDetailList.length > 0) {
              self.formDataPage.contractTaskDetailList.forEach((k) => {
                k.stateGuid=k.guid
                k.guid = null;
                k.isContractTask = k.isContractTask?k.isContractTask:'Y';
                // k.state=k.bizState//合同带出来的任务的作废状态
                
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取乙方
    getServiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9903', '9904'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取任务
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        isSuper: 'Y',
        // bizState:'Y'
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, query)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.taskList = res.data.data.records || [];
            if(self.taskList.length>0){
              self.taskList.forEach(item=>{
                item.taskName=item.bizState=='S'? item.taskContentName +' (已禁用)' :item.taskContentName
              })
            }
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 判重 1 付款信息类  2银行信息 3签约任务
    changeCheckRepeat(type, val, fieldName, index) {
      let list = [];
      if (type == 1) {
        list = this.payTypeJsonList;
      }
      if (type == 2) {
        list = this.formDataPage.contractBankList;
      }
      // if (type == 3) {不在这里面判断了
      //   list = this.formDataPage.contractTaskDetailList;
      // }
      
      
      for (var i = 0; i < list.length; i++) {
        for (var j = i + 1; j < list.length; j++) {
          if (list[i][fieldName] == list[j][fieldName] && val) {
          this.$confirm(`您在重复添加【${list[index].taskContentName}】任务，确定这样操作吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.$refs.taskSelect[index].blur()
          }).catch(() => {
            list[index][fieldName] = null;
            list[index].taskContentName = null;
            list[index].taskPrice = null;
            list[index].taskDescription = null;
          });
            // this.$message.error('已存在该类数据，请重新填入');

            console.log('8888', list[index]);
            
          }
        }
      }
    },
    taskChange(val, index, name) {
      if (val) {
        this.taskList.forEach((i) => {
          if (i.guid == val) {
             this.formDataPage.contractTaskDetailList[index].maxTaskPrice = '';
            this.formDataPage.contractTaskDetailList[index].taskPrice = i.tenantTaskPrice;
            this.formDataPage.contractTaskDetailList[index].priceType = '1';
            this.formDataPage.contractTaskDetailList[index].oldTaskContentName = i.taskContentName;
            this.formDataPage.contractTaskDetailList[index].taskContentName = i.taskContentName;
          }
        });
        
        // this.changeCheckRepeat(3, val, name, index);
        let list = this.formDataPage.contractTaskDetailList||[];
        let length = list.filter(item => item[name] === val).length;
        console.log('lle',length,val);
        if (length>1 && val) {
          this.$confirm(`您在重复添加【${list[index].taskContentName}】任务，确定这样操作吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.$refs.taskSelect[index].blur()
          }).catch(() => {
            list[index][name] = null;
            list[index].taskContentName = null;
            list[index].taskPrice = null;
            list[index].taskDescription = null;
          });
        }
      }
    },
    priceTypeChange(val, index, priceType){
      this.taskList.forEach((i) => {
          if (i.guid == val && priceType == 2) {
            this.formDataPage.contractTaskDetailList[index].taskPrice = i.tenantMinPrice;
            this.formDataPage.contractTaskDetailList[index].maxTaskPrice = i.tenantMaxPrice;
          }
           if (i.guid == val && priceType == 1) {
            this.formDataPage.contractTaskDetailList[index].taskPrice = i.tenantTaskPrice;
            this.formDataPage.contractTaskDetailList[index].maxTaskPrice = '';
          }
        });
    },
    checkSigning() {
      try {
        this.formDataPage.contractTaskDetailList.forEach((item) => {
          if (!item.templateDetailGuid) {
            throw new Error('签约任务中任务不能为空');
          }
          if (!item.taskContentName) {
            throw new Error('签约任务中项目任务名称不能为空');
          }
          if(!item.priceType){
            throw new Error('签约任务中价格类型不能为空');
          }
          if (item.priceType == 1 && !item.taskPrice) {
            throw new Error('签约任务中固定价格不能为空');
          }
          if (item.priceType == 2 && !item.taskPrice) {
            throw new Error('签约任务中最低价格不能为空');
          }
          if (item.priceType == 2 && !item.maxTaskPrice) {
            throw new Error('签约任务中最高价格不能为空');
          }
          if (item.priceType == 2 && (+item.maxTaskPrice <= +item.taskPrice)) {
            throw new Error('签约任务中最高价需大于最低价');
          }
    
        });
        return true;
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }
    },
    //添加签约任务
    addSigning() {
      if (!this.checkSigning())return;
      let item = {
        guid: null,
        templateDetailGuid: null,
        taskContentName: null,
        oldTaskContentName: null,
        taskPrice: null,
        taskDescription: null,
        isContractTask:'N',
        priceType:'1',
        maxTaskPrice:'',
        // state:'Y',//默认状态启用
      };
      this.formDataPage.contractTaskDetailList.push(item);
    },
    //删除签约任务
    delSigning(item) {
      if (this.formDataPage.contractTaskDetailList && this.formDataPage.contractTaskDetailList.length == 1) {
        this.$message.error('至少需有一条签约任务信息！');
        return;
      }
      let list=this.formDataPage.contractTaskDetailList.filter(item=>item.checked)
      console.log('list',list);
      
      if(!item&&list.length==0){
        this.$message.error('请选择要删除的签约任务！');
        return;
      }else if(list.length==this.formDataPage.contractTaskDetailList.length){
        this.$message.error('至少需有一条签约任务信息！');
        return;
      }
      this
        .$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          if(item)item.checked=true
          this.formDataPage.contractTaskDetailList=this.formDataPage.contractTaskDetailList.filter(item=>!item.checked)
          this.isBatch = false;
          this.buttonTxt = ''
          this.commandType =1;
          this.$forceUpdate()
        });
      
    },
    // 签约任务启用/停用
    changeState(item) {
      console.log('item',item);
      let list=this.formDataPage.contractTaskDetailList.filter(item=>item.checked)
      
      if(!item&&list.length==0){
        this.$message.error(`请选择要操作的签约任务！`);
        return;
      }else if(!item&&list.length>0){
        item=list[0]
      }
      let self=this
      let type=item.bizState=='Y'?'S':'Y'
      let req={
        bizState:type,
        guid:item.stateGuid
      }
      this
        .$confirm(`确定${type=='S'?'作废':'启用'}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.$message.success('修改成功');
            item.bizState=type
            this.formDataPage.contractTaskDetailList.filter(item=>{
              if(item.checked){
                item.bizState=type
              }
            })
            self.commandType =1;
            self.isBatch = false;
            self.buttonTxt = ''
        // self.fullscreenLoading = true;
        // self.api.postJson(`/${serverConfig.msCustomerService}/contract/update-task-detail-state`,req).then((res) => {
        //   self.fullscreenLoading = false;
        //   if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        //     self.$message.success('修改成功');
        //     item.bizState=type
        //   } else {
        //     self.$message.error(res.data.msg);
        //   }
        // });
      });
    },
    //提交申请 type为1时保存否则提交
    saveReq(type) {
      if (!this.formDataPage.contractGuid) {
        this.$message.error('请选择合同');
        return;
      }
      if (!this.checkSigning()) return;
      let reqUrl = '/contract/add-approve-contract-task';
      let form = JSON.parse(JSON.stringify(this.formDataPage));
      //当前登录人信息
      let userinfo = JSON.parse(localStorage.userInfo);
      form.staffGuid = userinfo.staffGuid;
      form.staffName = userinfo.staffName;
      form.userTenantGuid = localStorage.guid;
      if (this.$route.query.toType == 3) {
        //重新提交时
        form.guid = null;
        form.discardContractGuid = this.$route.query.guid;
      }
      if (type == 0 && !this.$route.query.guid) {
        //新增保存草稿
        form.isSaveDraft = true;
      }
      if (type == 0 && this.$route.query.guid) {
        //编辑保存草稿
        form.isSaveDraft = true;
        form.guid = this.$route.query.guid;
        reqUrl = '/contract/update-draft-contract-task';
      }
      //编辑的时候提交流程
      if (type == 1 && this.$route.query.approveStateTask == 'N') {
        form.guid = this.$route.query.guid;
        reqUrl = '/contract/update-draft-contract-task';
      }
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msCustomerService}${reqUrl}`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: messageConfig.SUBMIT_SUCCESS,
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error(messageConfig.FLOW_NO_ID);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    
    //清空
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', //甲方
        serviceTenantGuid: '', //乙方
        staffGuid: '',
        contractName: '',
        approveState: '',
      };
      this.getContractList(1);
    },
    // 分页
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getContractList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getContractList();
    },
  },
};
</script>
<style scoped>
/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
  padding: 20px;
  padding-bottom: 15px;
}
.contract-information-page {
  overflow: auto;
}

.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}

.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
.contract-base-button{
  text-align: left;
  margin-left: 23px;
  overflow: hidden;
  height: 32px;
  margin-bottom: 0;
 }
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 32px;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  /* margin-bottom: 23px; */
}
.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
}
.contract-base-box .el-col-12,
.contract-base-box .el-col-14,
.contract-base-box .el-col-10,
.contract-base-box .el-col-24,
.contract-base-box .el-col-7,
.contract-base-box .el-col-6 {
  min-height: 37px;
  display: flex;
  /* align-items: center; */
  margin-bottom: 8px;
  padding-right: 20px;
  box-sizing: border-box;
}

.contract-base-title {
  flex-shrink: 0;
  width: 140px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}

.contract-base-content {
  width: 314px;
  text-align: left;
  line-height: 36px;
}

/deep/.el-radio-group {
  padding-top: 5px !important;
}

.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}

/* 添加银行 */
.add-bank-box {
  color: #4fa1a4;
  margin-left: 15px;
  line-height: 36px;
}

.add-bank-box span {
  cursor: pointer;
}

.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}

.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
.el-col-6 {
  display: flex;
  /* margin-bottom: 10px; */
}
.el-col-24{
  display: flex;
  margin-bottom: 15px;
}
.search-area-div {
  width: 90px;
  text-align: right;
}
.ipt-sty {
  flex: 1;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
}
.file-box .search-area-div{
  flex-shrink: 0;
  width: 135px;
}
.span-flex{
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-button--primary:focus, .el-button--primary:hover{
    border-color: #4fa1a4;
    background: #4fa1a4;
}
.setting-btn{
  font-size: 12px;
  color: #fff !important;
  background-color: #4fa1a4;
  border-color: #4fa1a4;
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding:6px 15px;
  cursor:pointer;
}


</style>
